export default __webpack_public_path__ + "static/media/10.1d8f8c07.jpg";